/** The auth context; throws when used outside AuthProvider. */

import { useContext } from 'react';
import { AuthContext } from '@/providers/auth-provider';

/**
 * Hook to access authentication context
 * Must be used within an AuthProvider
 * @returns Authentication context with user state and auth methods
 * @throws Error if used outside of AuthProvider
 */
export const useAuth = () => {
  const context = useContext(AuthContext);
  
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
};
